import {NgClass, TitleCasePipe}                                                                                                                                                         from '@angular/common';
import {AfterViewInit, Component, ElementRef, inject, OnDestroy, ViewChild}                                                                                                             from '@angular/core';
import {foodAnalysisNutritionDetailDict, foodAnalysisNutritionDetailKeys, FoodAnalysisRatingDict, FoodAnalysisTotalsDict, foodAnalysisTotalsKeys, FoodRecordLogIntf, FoodRecordSumIntf} from '@djsharkk/logr-types';
import {PressHoldDirective}                                                                                                                                                             from '../../../../../../../logr-services/directives/press-hold.directive';
import {MenuBaseService}                                                                                                                                                                from '../../../../../utils/menu-base.service';
import {MenuCrudPanelContentBase}                                                                                                                                                       from '../../menu-crud-panel-content-base';
import {MenuCrudPanelTopComponent}                                                                                                                                                      from '../menu-crud-panel-top.component';
import {MenuCrudPanelFoodService}                                                                                                                                                       from './menu-crud-panel-food.service';

// gsap.registerPlugin(ScrollToPlugin)


@Component({
			   selector   : 'app-menu-crud-food',
			   templateUrl: './menu-crud-panel-food-top.component.html',
			   imports: [
				   NgClass,
				   MenuCrudPanelTopComponent,
				   TitleCasePipe,
				   PressHoldDirective
			   ],
			   styleUrls  : ['./menu-crud-panel-food-top.component.css']
		   })
export class MenuCrudPanelFoodTopComponent extends MenuCrudPanelContentBase<FoodRecordLogIntf, FoodRecordSumIntf> implements AfterViewInit, OnDestroy {
	@ViewChild('videoPlayer', {static: true}) refVideo!: ElementRef<HTMLVideoElement>;
	@ViewChild('canvas', {static: true}) refCanvas!: ElementRef<HTMLCanvasElement>;

	svcMenuCrudFood = inject(MenuCrudPanelFoodService)
	svcMenuBase = inject(MenuBaseService)


	private stream: MediaStream | null = null;

	foodRecordNew: FoodRecordLogIntf | null = null;

	captureInProgress = false;


	constructor() {
		super('food', false);

	}

	ngAfterViewInit(): void {
		this.svcMenuBase.svcMenuCrud.menuType.subscribe(type => {
			if (type === 'food') {
				this.initCaptureMode()
				// this.svcMenuCrud.crudMenuFoodMode = 'reviewing';
				// this.foodRecordNew = this.svcDataFactory.svcDataFood.getRecordsLog().getValue()[0];
			} else {
				this.stopCaptureStream();
			}
		})
		this.refVideo.nativeElement.addEventListener('playing', () => this.svcMenuCrudFood.draw(this.refVideo, this.refCanvas));
	}

	async runCamera() {
		try {
			this.stream = await navigator.mediaDevices.getUserMedia({video: {facingMode: {exact: 'environment'}}});

			if (this.refVideo.nativeElement && this.stream) {
				this.refVideo.nativeElement.srcObject = this.stream;
				this.refVideo.nativeElement.style.objectFit = 'cover';
			}
		} catch (error) {
			console.error('Error accessing camera: ', error);
		}
	}

	// async captureImage(): Promise<void> {
	// 	if (this.captureInProgress) return;
	// 	this.captureInProgress = true;
	//
	// 	const imageBlob = await this.svcMenuCrudFood.processImage(this.refVideo, this.refCanvas)
	// 	if (!imageBlob) {
	// 		console.error('Failed to capture image');
	// 		return
	// 	}
	//
	// 	this.stopCaptureStream();
	// 	this.foodRecordNew = await this.svcMenuCrudFood.captureUpload(imageBlob)
	// 	this.captureInProgress = false;
	// }

	async captureImage(): Promise<void> {
		if (this.captureInProgress) return;
		this.captureInProgress = true;

		try {
			const imageBlob = await this.svcMenuCrudFood.processImage(this.refVideo, this.refCanvas);
			if (!imageBlob) {
				console.error('Failed to capture image');
				return;
			}

			this.stopCaptureStream();

			this.foodRecordNew = await this.svcMenuCrudFood.captureUpload(imageBlob);
		} catch (error) {
			console.error('Unexpected error in captureImage():', error);
		} finally {
			this.captureInProgress = false;
		}
	}


	override ngOnDestroy(): void {
		this.stopCaptureStream();
	}

	stopCaptureStream() {
		if (this.stream) {
			if (this.svcMenuBase.svcMenuCrud.crudMenuFoodMode !== 'processing') {
				this.svcMenuBase.svcMenuCrud.crudMenuFoodMode = 'awaiting';
			}
			this.stream.getTracks().forEach((track) => track.stop());
		}
	}



	async initCaptureMode() {
		await this.runCamera()
		this.svcMenuBase.svcMenuCrud.crudMenuFoodMode = 'capturing';
	}

	public disableCaptureMode() {
		this.stopCaptureStream();
		this.svcMenuBase.svcMenuCrud.crudMenuFoodMode = 'awaiting';
	}

	public closeMenuCrudFood() {
		this.disableCaptureMode();
		this.svcMenuBase.menuCrudClose()
	}

	protected readonly foodAnalysisTotalsDict = FoodAnalysisTotalsDict;
	protected readonly foodAnalysisTotalsKeys = foodAnalysisTotalsKeys;
	protected readonly foodAnalysisNutritionDetailKeys = foodAnalysisNutritionDetailKeys;
	protected readonly foodAnalysisNutritionDetailDict = foodAnalysisNutritionDetailDict;
	protected readonly FoodAnalysisRatingDict = FoodAnalysisRatingDict;
}